import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import User from 'flarum/common/models/User';
import Model from 'flarum/common/Model';
import Post from 'flarum/forum/components/Post';
import SettingsPage from 'flarum/forum/components/SettingsPage';

import CustomCssSettingsItem from './components/CustomCssSettingsItem';
import ShowOthersCssSettingsItem from './components/ShowOthersCssSettingsItem';

app.initializers.add('kemze-user-css', () => {
	// Makes user.customCss() / user.save({ customCss }) available.
	User.prototype.customCss = Model.attribute('customCss');
	User.prototype.customCssRaw = Model.attribute('customCssRaw');
	User.prototype.canUseCustomCss = Model.attribute('canUseCustomCss');

	// One <style> tag per author, injected the first time one of their
	// posts is rendered on this page. Avoids re-injecting the same CSS
	// for every post by a prolific author.
	const injectedUserIds = new Set();

	function othersCssEnabled() {
		// Guests have no preferences to check, so they always see everyone's
		// styling.
		if (!app.session.user) return true;

		return app.session.user.preferences()['kemze-user-css.showOthersCss'] !== false;
	}

	function ensureCssInjected(user) {
		if (!user) return;

		const id = user.id();
		const isSelf = app.session.user && app.session.user.id() === id;

		if (!isSelf && !othersCssEnabled()) return;

		const css = user.customCss();

		if (!css || injectedUserIds.has(id)) return;

		const style = document.createElement('style');
		style.id = `KemzeUserCss-${id}`;
		style.textContent = css;
		document.head.appendChild(style);

		injectedUserIds.add(id);
	}

	function tagAndInject(component) {
		const user = component.attrs.post && component.attrs.post.user();

		if (!user || !component.element) return;

		component.element.classList.add(`PostUser-${user.id()}`);
		ensureCssInjected(user);
	}

	extend(Post.prototype, 'oncreate', function () {
		tagAndInject(this);
	});

	extend(Post.prototype, 'onupdate', function () {
		tagAndInject(this);
	});

	// Visible to everyone: this controls what a person sees, not whether
	// they can write their own CSS, so it isn't gated on the permission.
	extend(SettingsPage.prototype, 'settingsItems', function (items) {
		items.add('kemzeUserCssShowOthers', <ShowOthersCssSettingsItem />, 6);

		if (!app.session.user.canUseCustomCss()) return;

		items.add('customCss', <CustomCssSettingsItem />, 5);
	});
});
